"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var refPropType = function refPropType(props, propName, componentName) {
  if (typeof props[propName] === 'object' && props[propName].hasOwnProperty('current')) {
    return null;
  }

  return new Error(componentName + ": Invalid " + propName + " value. Expected an object created with React.createRef().");
};

var _default = (0, _createChainablePropType.default)(refPropType, 'ref object');

exports.default = _default;
module.exports = exports.default;